var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-3"},[_c('v-btn',{staticClass:"text-uppercase text-decoration-underline text-body-2",class:_vm.buttonColorClass,attrs:{"text":""},on:{"click":_vm.openModal}},[_vm._v(" Choose which companies can buy your info ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }